const isEmpty = (value: any) => {
	if (!value || (typeof value === "object" && !Object.keys(value).length))
		return true;
	return false;
};

export { isEmpty };
